// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__bZ9-h","rootCenter":"LoadMoreObserver_rootCenter__1joBY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2FnOI"};